// get the elements we want to work with
const targetElement = document.querySelector('product-form');
const dependentElement = document.querySelector('.productModal-wrapper');
const footer = document.querySelector('#shopify-section-footer')

// create an intersection observer
const observer = new IntersectionObserver((entries, observer) => {
    if (entries[0].isIntersecting) {
        // Slide up and hide
        requestAnimationFrame(() => {
            dependentElement.style.transform = 'translateY(100%)'; // Adjust as needed to slide out
            dependentElement.style.opacity = '0';
            footer.style.marginBottom = '0px';
            // Use setTimeout to delay setting visibility to hidden to allow the transition to complete
            setTimeout(() => {
                dependentElement.style.visibility = 'hidden';
            }, 500); // Match the duration of your CSS transition
        });
    } else {
        // Slide in and show
        requestAnimationFrame(() => {
            dependentElement.style.visibility = 'visible';
            dependentElement.style.transform = 'translateY(0%)';
            dependentElement.style.opacity = '1';
            footer.style.marginBottom = '113px'; // Adjust the margin as necessary
        });
    }
});


// start observing the target element
observer.observe(targetElement);
